import { parseToJson } from "./parseToJson";

export function getItem(key = "", defaultValue = "") {
  if (!key) return console.error("Key is missing");

  return parseToJson(localStorage.getItem(key) ?? defaultValue, defaultValue);
}
